// extracted by mini-css-extract-plugin
module.exports = {"google":"SignInWithGoogle_google__3mSFA","icon":"SignInWithGoogle_icon__1G30r"};